export const serverUrl = 'https://api.kleksi.com/apps/sofco/admin';
export const PRODUCTION = false;
